import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import PersonalityTypeStep from "../components/onboarding/PersonalityTypeStep";
import BodyTypeStep from "../components/onboarding/BodyTypeStep";
import WelcomeStep from "../components/onboarding/WelcomeStep";
import AgeStep from "../components/onboarding/AgeStep";
import GoalStep from "../components/onboarding/GoalStep";
import PersonalityAttributesStep from "../components/onboarding/PersonalityAttributesStep";
import ActivitiesStep from "../components/onboarding/ActivitiesStep";
import BreastSizeStep from "../components/onboarding/BreastSizeStep";
import ButtSizeStep from "../components/onboarding/ButtSizeStep";
import LegsTypeStep from "../components/onboarding/LegsTypeStep";
import HairColorStep from "../components/onboarding/HairColorStep";
import HobbiesStep from "../components/onboarding/HobbiesStep";
import FreeTimeStep from "../components/onboarding/FreeTimeStep";
import SpecialPhotosStep from "../components/onboarding/SpecialPhotosStep";
import SpecialVideosStep from "../components/onboarding/SpecialVideosStep";
import VoiceMessagesStep from "../components/onboarding/VoiceMessagesStep";
import LoadingStep from "../components/onboarding/LoadingStep";
import EmailStep from "../components/onboarding/EmailStep";
import PaymentStep from "../components/onboarding/PaymentStep";
import CompletionStep from "../components/onboarding/CompletionStep";

const TOTAL_STEPS = 20;

const Onboarding = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [onboardingData, setOnboardingData] = useState({
    personalityType: "",
    bodyType: "",
    age: "",
    goal: "",
    personalityAttributes: [],
    activities: "",
    breastSize: "",
    buttSize: "",
    legsType: "",
    hairColor: "",
    hobbies: [],
    freeTime: "",
    specialPhotos: "",
    specialVideos: "",
    voiceMessages: "",
    email: "",
    selectedPlan: "",
  });

  const updateData = (field, value) => {
    setOnboardingData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const nextStep = () => {
    if (currentStep < TOTAL_STEPS) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        // return <EmailStep
        //     data={onboardingData}
        //     updateData={updateData}
        //     onNext={nextStep}
        //   />
        return (
          <PersonalityTypeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      // return <PaymentStep data={onboardingData} updateData={updateData} onNext={nextStep} />;
      case 2:
        return (
          <BodyTypeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 3:
        return <WelcomeStep onNext={nextStep} />;
      case 4:
        return (
          <AgeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 5:
        return (
          <GoalStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 6:
        return (
          <PersonalityAttributesStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 7:
        return (
          <ActivitiesStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 8:
        return (
          <BreastSizeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 9:
        return (
          <ButtSizeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 10:
        return (
          <LegsTypeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 11:
        return (
          <HairColorStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 12:
        return (
          <HobbiesStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 13:
        return (
          <FreeTimeStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 14:
        return (
          <SpecialPhotosStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 15:
        return (
          <SpecialVideosStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 16:
        return (
          <VoiceMessagesStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 17:
        return <LoadingStep onNext={nextStep} />;
      case 18:
        return (
          <EmailStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 19:
        return (
          <PaymentStep
            data={onboardingData}
            updateData={updateData}
            onNext={nextStep}
          />
        );
      case 20:
        return <CompletionStep data={onboardingData} />;
      default:
        return null;
    }
  };

  const progressPercentage = (currentStep / TOTAL_STEPS) * 100;

  return (
    <div className="min-h-screen bg-[#0E0E0E] flex flex-col">
      {/* Header with back button and progress bar */}
      <div className="p-4 md:p-6">
        {currentStep > 1 && currentStep < 20 && currentStep !== 17 && (
          <button
            onClick={prevStep}
            className="text-white mb-4 hover:text-[#F1B428] transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft size={32} />
          </button>
        )}

        {currentStep < 20 && currentStep !== 17 && currentStep !== 19 && (
          <div className="w-full max-w-md mx-auto bg-white/10 backdrop-blur-sm rounded-full h-2 overflow-hidden">
            <div
              className="h-full bg-[#F1B428] transition-all duration-500 ease-out shadow-lg shadow-[#F1B428]/50"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        )}
        {currentStep < 14 && (
          <div className="flex items-center justify-center mt-4 mb-8">
            <img
              src="/logo.png" // replace with your logo path
              alt="Butterscotch Logo"
              className="h-5 w-5 md:h-5 md:w-5 mr-1"
            />
            <span className="text-[#a8a8a8] text-2l md:text-2l">
              ButterscotchAI
            </span>
          </div>
        )}
      </div>

      {/* Step Content */}
      <div className="flex-1 flex items-start justify-center px-4 pb-8">
        <div className="w-full max-w-md">{renderStep()}</div>
      </div>
    </div>
  );
};

export default Onboarding;
